import { cn } from "cn";
import { BwDiamondLine } from "@/components/ui/icons";
import type { PurchaseIntentCheckoutLineItem } from "@/features/shared/checkout-summary";

/**
 * The service credit the campaign link sells, as a confirmation — not a choice.
 *
 * The tier is fixed by the `CheckoutLink` the invitation carried and bound to the
 * `PurchaseIntent` back in step 2, so this page only restates it — read off the
 * reservation's own cart rather than re-resolved from the checkout-link catalog.
 *
 * Presented as the member checkout's product card (`CheckoutLineItem`) minus its
 * checkbox: presale has nothing to select, so the card states the credit read-only.
 */
export function PresaleServiceCreditCard({
  credit,
}: {
  credit: PurchaseIntentCheckoutLineItem | undefined;
}) {
  // Also covers the link that sells no credit at all — there is no card to show, rather
  // than a $0.00 one.
  if (!credit?.price?.unitAmount) return null;

  return (
    <div
      className={cn(
        /* sorted */
        "p-4",
        "outline outline-outline-dark-low rounded-2xl",
      )}
    >
      <div className="flex items-center gap-2">
        <BwDiamondLine size={20} className="text-text-warning shrink-0" />
        <p className="font-medium text-sm grow">Service credit</p>
      </div>
      <div className="mt-2 flex items-center justify-between gap-1">
        <p className="font-medium text-sm">{credit.price.formattedPrice}</p>
        <p className="text-text-dark-high text-sm grow">One-time</p>
      </div>
      <p className="text-text-dark-high text-sm mt-2">
        Prepaid balance for your first services — waiting in your wallet when we
        launch in your area.
      </p>
    </div>
  );
}
